<template>
  <div>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">
              Member Name
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in participants" :key="item.uuid">
            <td v-if="item.member">{{ item.member.display_name }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
export default {
  name: "ParticipantsList",

  props: ["participants"],
  components: {},

  data: () => ({
    loading: false,
  }),

  methods: {
    submit() {
      this.loading = true;
    },
    deleteParticipant(id) {
      this.$emit('deleteParticipant', id);
    }
  },
};
</script>
